import React, { useRef } from "react";

const ShopSearchForm: React.FC<{ value: string; onClick: any }> = ({
  value,
  onClick,
}) => {
  const searchText = useRef<HTMLInputElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick(searchText.current?.value);
    e.preventDefault();
  };

  return (
    <>
      <form role="search" method="get" id="searchform" className="search-form">
        <div>
          <label className="screen-reader-text" htmlFor="s"></label>
          <input
            ref={searchText}
            type="search"
            className="search-field"
            placeholder="ショップ・イベント名を入力"
            defaultValue={value}
            name="s"
            id="s"
          />
          <button type="submit" className="submit-button" onClick={handleClick}>
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.774 23.471L21.4881 18.1851C21.2495 17.9465 20.9261 17.814 20.5868 17.814H19.7226C21.1859 15.9424 22.0554 13.5884 22.0554 11.0277C22.0554 4.93595 17.1194 0 11.0277 0C4.93595 0 0 4.93595 0 11.0277C0 17.1194 4.93595 22.0554 11.0277 22.0554C13.5884 22.0554 15.9424 21.1859 17.814 19.7226V20.5868C17.814 20.9261 17.9465 21.2495 18.1851 21.4881L23.4709 26.774C23.9693 27.2723 24.7752 27.2723 25.2682 26.774L26.7687 25.2736C27.267 24.7752 27.267 23.9693 26.774 23.471ZM11.0277 17.814C7.27933 17.814 4.24142 14.7813 4.24142 11.0277C4.24142 7.27933 7.27403 4.24142 11.0277 4.24142C14.776 4.24142 17.814 7.27403 17.814 11.0277C17.814 14.776 14.7813 17.814 11.0277 17.814Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      </form>
    </>
  );
};

export default ShopSearchForm;
